// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip{width:25rem;transform:translate(-50%, -100%)}.tooltip-arrow{transform:translate(50%)}", ""]);
// Exports
module.exports = exports;
